import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledReceiveInPerson = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			rx: 8,
			fill: "#FEF6EA"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 3.11111,
			cy: 3.11111,
			r: 2.61111,
			transform: "matrix(-1 0 0 1 14.9727 4)",
			fill: "white",
			stroke: "#B47F23"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.0635 10.5703C9.12909 10.5704 8.31952 11.2176 8.11328 12.1289L6.92578 17.3789C6.643 18.6298 7.59446 19.8203 8.87695 19.8203H13.5723C15.88 19.8203 17.5564 17.6259 16.9492 15.3994L16.0342 12.0439C15.7969 11.1739 15.0063 10.5704 14.1045 10.5703H10.0635Z",
			fill: "white",
			stroke: "#B47F23",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.75 14.0703L14.2655 16.1324C14.3846 16.6088 14.0243 17.0703 13.5333 17.0703H10.6321C9.87589 17.0703 9.26955 17.6959 9.29318 18.4518C9.31578 19.175 9.90859 19.7496 10.6321 19.7496H12.8337",
			stroke: "#B47F23",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5 12.4583V14.2083C6.5 15.3082 6.5 15.8583 6.84183 16.1998C7.18367 16.5414 7.73346 16.5417 8.83333 16.5417H9.70833C10.8082 16.5417 11.3583 16.5417 11.6998 16.1998C12.0414 15.858 12.0417 15.3082 12.0417 14.2083V12.4583M6.89958 11.821L6.5 12.4583H12.0417L11.6765 11.8496C11.4274 11.4346 11.3032 11.2272 11.1022 11.1135C10.9018 11 10.6597 11 10.1759 11H8.38213C7.90875 11 7.67192 11 7.47417 11.1094C7.27642 11.219 7.15071 11.4197 6.89958 11.821ZM9.27083 12.4583V11V12.4583ZM8.6875 13.7715H9.85417H8.6875Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0417 12.4583L11.6765 11.8496C11.4274 11.4346 11.3032 11.2272 11.1022 11.1135C10.9018 11 10.6598 11 10.1759 11H8.38213C7.90875 11 7.67192 11 7.47417 11.1094C7.27642 11.219 7.15071 11.4197 6.89958 11.821L6.5 12.4583V14.2083C6.5 15.3082 6.5 15.8583 6.84183 16.1998C7.18367 16.5414 7.73346 16.5417 8.83333 16.5417H9.70833C10.8082 16.5417 11.3583 16.5417 11.6998 16.1998C12.0414 15.858 12.0417 15.3082 12.0417 14.2083V12.4583ZM6.5 12.4583H12.0417M9.27083 12.4583V11M8.6875 13.7715H9.85417",
			stroke: "#B47F23",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgFilledReceiveInPerson);
const Memo = memo(ForwardRef);
export default Memo;
